import { useEffect, useState } from 'react';

const LAST_USED_AUTH_METHOD_KEY = 'luckynote.lastUsedAuthMethod';
const PENDING_SOCIAL_AUTH_METHOD_KEY = 'luckynote.pendingSocialAuthMethod';

const AUTH_METHODS = new Set(['email', 'google', 'apple']);

const isAuthMethod = method => AUTH_METHODS.has(method);

export const getLastUsedAuthMethod = () => {
    try {
        const method = window.localStorage.getItem(LAST_USED_AUTH_METHOD_KEY);
        return isAuthMethod(method) ? method : null;
    } catch (_error) {
        return null;
    }
};

export const rememberLastUsedAuthMethod = method => {
    if (!isAuthMethod(method)) return;

    try {
        window.localStorage.setItem(LAST_USED_AUTH_METHOD_KEY, method);
    } catch (_error) {
        // Storage can be disabled; the sign-in flow must still work normally.
    }
};

export const rememberPendingSocialAuthMethod = method => {
    if (!isAuthMethod(method) || method === 'email') return;

    try {
        window.sessionStorage.setItem(PENDING_SOCIAL_AUTH_METHOD_KEY, method);
    } catch (_error) {
        // This is only a cosmetic hint after the redirect.
    }
};

export const consumePendingSocialAuthMethod = () => {
    try {
        const method = window.sessionStorage.getItem(PENDING_SOCIAL_AUTH_METHOD_KEY);
        window.sessionStorage.removeItem(PENDING_SOCIAL_AUTH_METHOD_KEY);
        return isAuthMethod(method) && method !== 'email' ? method : null;
    } catch (_error) {
        return null;
    }
};

// Match the anonymous prerender before restoring browser-only preferences.
export const useLastUsedAuthMethod = () => {
    const [method, setMethod] = useState(null);
    useEffect(() => { setMethod(getLastUsedAuthMethod()); }, []);
    return [method, setMethod];
};
